<template>
<div class="w-100 login-right pr-5 pt-5">
    
    <div class="d-block login-text text-right">
        <span class="float-left pl-5"><a href="javascript:void(0)"  @click="goBack()" class="no-style">< назад</a></span>
        <span class="have-account mr-3">Уже есть аккаунт?</span>
        <span class="login-text">
            <a href="/#/login" class="no-style">{{$t('regForm.login')}}</a>
        </span>
    </div>
    <div class="reg-form pt-5">
        <h5 class="reg-title text-center">Регистрация</h5>
        <div class="btn-container text-center mt-4">
            <a href="/#/reg/person" style="text-decoration: none;" class="d-inline-block active-btn-container px-3 py-2 mr-5">
                <span class="active-btn-text">Физ.лицо</span>
            </a>
            <a
              href="javascript:void(0)"
              class="d-inline-block inactive-btn-container px-3 py-2"
              style="text-decoration: none;"
              @click.prevent="onLegalEntityComingSoon"
            >
              <span class="inactive-btn-text">Юр лицо</span>
            </a>
        </div>
        <div class="sm-sep mt-4"></div>
        <div class="input-container">
            <router-view></router-view>     
        </div>
    </div>
</div>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeaderOpen} from "@/config/config";
    import vue from 'vue';
    export default{
        name:"Reg",
        comments:{
            
        },
        methods:{
            goBack() {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                this.$router.push("/landing");
            }
            },
            onLegalEntityComingSoon() {
              if (this.$bvToast) {
                this.$bvToast.toast('Регистрация для юридических лиц пока в разработке.', {
                  title: 'В разработке',
                  variant: 'info',
                  autoHideDelay: 4500,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                });
              }
            },
        }
        
       

    }
</script>
<style>
    .ins-item{
        margin-bottom: 10px;
        
    }
    .ins-item-text{
        color: var(--Chart-Green, #00C076);
        /* Caption 2 */
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
    }
    .reg-step-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
    }
    .reg-step-title{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px; /* 125% */
        letter-spacing: -0.96px;
    }
    .back-btn-container{
        cursor: pointer;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .back-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;

        /* Button 1 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px; /* 100% */
    }
    .web-camera-container {
        margin-top: 2rem;
        margin-bottom: 2rem;
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 4px;
        width: 100%;

        
        .camera-button {
            margin-bottom: 2rem;
        }
        
        .camera-box {    
            .camera-shutter {
                opacity: 0;
                width: 70%;
                height: 40px;
                background-color: #fff;
                position: absolute;
                
                &.flash {
                    opacity: 1;
                }
            }
        }
        
        .camera-shoot {
            margin: 1rem 0;
            
            button {
                height: 60px;
                width: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 100%;
                
                img {
                    height: 35px;
                    object-fit: cover;
                }
            }
        }
        
        .camera-loading {
            overflow: hidden;
            height: 100%;
            position: absolute;
            width: 100%;
            min-height: 150px;
            margin: 3rem 0 0 -1.2rem;
            
            ul {
            height: 100%;
            position: absolute;
            width: 100%;
            z-index: 999999;
            margin: 0;
            }
            
            .loader-circle {
                display: block;
                height: 14px;
                margin: 0 auto;
                top: 50%;
                left: 100%;
                transform: translateY(-50%);
                transform: translateX(-50%);
                position: absolute;
                width: 100%;
                padding: 0;
                
                li {
                    display: block;
                    float: left;
                    width: 10px;
                    height: 10px;
                    line-height: 10px;
                    padding: 0;
                    position: relative;
                    margin: 0 0 0 4px;
                    background: #999;
                    animation: preload 1s infinite;
                    top: -50%;
                    border-radius: 100%;
                    
                    &:nth-child(2) {
                    animation-delay: .2s;
                    }
                    
                    &:nth-child(3) {
                    animation-delay: .4s;
                    }
                }
            }
        }

        @keyframes preload {
            0% {
            opacity: 1
            }
            50% {
            opacity: .4
            }
            100% {
            opacity: 1
            }
        }
    }
    .submit-btn{
        appearance: none; 
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
        border-radius: 12px;
        border:1px solid var(--Primary-1, #EFB914);
        background: var(--Primary-1, #EFB914);
    }
    .submit-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .reg-label{
        color: var(--Neutrals-5, #B1B5C3);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 12px; /* 100% */
        text-transform: uppercase;
    }
    .reg-input{
        color: var(--Neutrals-4, #777E90);

        /* Caption (Bold) */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 171.429% */
        appearance: none; 
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        
        line-height: inherit;
        padding: 0;
        margin: 0;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
        
    }
    .custom-select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        padding: 0 20px 0 0; /* Adjust padding to leave space for custom arrow */
        margin: 0;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
        position: relative;
    }

    .custom-select::after {
        content: '\25BC'; /* Unicode character for down arrow */
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        pointer-events: none;
        color: var(--Neutrals-4, #777E90); /* Match arrow color with text color */
    }
    .sm-sep{
        height: 1px;
        border-radius: 1px;
        background: var(--Neutrals-3, #353945);
    }
    .inactive-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .inactive-btn-container{
        cursor: pointer;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .active-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .active-btn-container{
        cursor: pointer;
        border-radius: 12px;
        background: var(--Primary-1, #EFB914);
    }
    .reg-title{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 48px;
        letter-spacing: -1.2px;
    }
    .reg-form{
        display: block;
        width: 100%;
        max-width: 380px;
        margin: 0 auto;
    }
    .no-style {
        color: inherit; /* Inherit color from parent */
        text-decoration: none; /* Remove underline */
    }
    .login-text{
        color: var(--Primary-1, #EFB914);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .have-account{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .login-right{
        background: var(--Neutrals-1, #141416);
        min-height: 110vh;
    }   
</style>
